<span class="pulse" [ngStyle]="{ 'background-color': color }"></span>
